import UInputNumber from "@nuxt/ui/components/InputNumber.vue";
import { defineNuxtPlugin } from "nuxt/app";

// Defaults UInputNumber partagés web/mobile. Override possible au call site.
// - disableWheelChange = true : sinon scroller la page modifie la valeur du
//   champ qui a le focus.
// - orientation = "vertical" : flèches +/- empilées à droite (cohérent avec
//   nos overrides de slots increment/decrement dans ui-theme.ts).
// Cast nécessaire : le type SFC exposé par Nuxt UI ne décrit pas `.props` (setup style).
export default defineNuxtPlugin(() => {
  const props = (UInputNumber as unknown as { props: Record<string, { default?: unknown }> }).props;
  if (!props) return;
  if (props.disableWheelChange) props.disableWheelChange.default = true;
  if (props.orientation) props.orientation.default = "vertical";
});
